import { render, staticRenderFns } from "./AdminSideBar.vue?vue&type=template&id=3bd6f601&"
import script from "./AdminSideBar.vue?vue&type=script&lang=js&"
export * from "./AdminSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports